export default __webpack_public_path__ + "static/media/Athenian-Black.17a628a0.jpg";